<template>

	<div id="app" v-if="isFull">

		<nav-header-alt />

		<router-view class="view-content"></router-view>

		<founder-thoughts v-if="founderThoughts && isNotTextual" />

		<contact-section v-if="contactSection && isNotTextual" />

		<nav-footer @displaySiteMap="$refs.siteMapModal.display()" :hide-logo-belt="!isNotTextual" />

		<siteMapModal ref="siteMapModal" />

	</div>

</template>

<script>
/* eslint-disable */
import navHeaderAlt from './components/nav-header-alt.vue';
import navFooter from './components/nav-footer.vue';
import founderThoughts from './views/FounderThoghts.vue';
import contactSection from './components/contact-section.vue';
import siteMapModal from './components/site-map-modal.vue';

import { mapActions } from 'vuex';
import ContactSection from './components/contact-section.vue';

export default {
	name: 'App',
	props: {
		contactSection: {
			type: Boolean,
			default: true
		},
		founderThoughts: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		isNotTextual() {
			const textualRoutes = ['Page'];
			return !textualRoutes.includes(this.$route.name);
		}
	},
	components: {
		navHeaderAlt,
		navFooter,
		founderThoughts,
		ContactSection,
		siteMapModal
	},
	data: () => {
		return {
			sample: false,
			isFull: true
		};
	},
	mounted() {
		// document.addEventListener('DOMContentLoaded', () => {
		if (window.mainUI && typeof window.mainUI === 'function') {
			window.mainUI();
		}
		// });
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.adjustViewMargin);
	},
	watch: {
		$route(to, from) {
			if (this.isFull && to.name && to.name !== from.name) {
				this.$nextTick(() => {
					this.scrollTo();
				});
			}
		},
	},
	methods: {
		...mapActions(['catalogUpdate']),
		scrollTo() {
			// if(to.name && to.name !== from.name){
			window.scrollTo({
				top: 0,
				// behavior: 'smooth'
			});
			// }
		},
		adjustViewMargin() {
			const footer = document.getElementById('nav-footer');
			const view = document.getElementById('view');
			if (footer && view) {
				view.style.marginBottom = `${footer.offsetHeight - 80 / 2}px`;
			}
			setTimeout(() => {
				this.adjustHeaderMargin();
			}, 400);
			// this.adjustHeaderMargin();
		},
		adjustHeaderMargin() {
			const header = document.getElementById('nav-header');
			const view = document.getElementById('view');
			if (header && view) {
				view.style.marginTop = `${header.offsetHeight}px`;
			}
		},
		loadScript(scriptURI) {
			// This is necessary to force Vue to insert the cordova.js plugin.
			var script = document.createElement("script");
			script.setAttribute("src", scriptURI);
			script.setAttribute("type", "text/javascript");
			document.getElementsByTagName("head")[0].appendChild(script);
		}
	},
	async beforeMount() {
		this.isFull = false;
		try {
			await this.catalogUpdate();
			document.addEventListener('DOMContentLoaded', () => {
				// await this.recoverFromDixie();
				this.isFull = true;
			});
		} catch (error) {
			console.error('Error updating catalog:', error);
		} finally {
			this.isFull = true;
		}
	}
}
</script>

<style lang="scss">
#app {

	blockquote {
		background-color: hsla(0, 0%, 80%, 0.25);
		padding: 24px 48px;
		border-radius: 0 0 5px 5px ;
		border-color: var(--primary);
		border-top: 1px solid var(--primary);
	}


	.limit-width {
		max-width: 1280px;
		margin: 0 auto;
		padding: 12px 36px;
	}

	.divider {
		max-width: 1500px;
		margin: 0 auto;
		padding: 0;

		&.inverted {
			border-top-color: rgba(255, 255, 255, 0.14);
			background: #0F1824;
			margin-top: 0 !important;
			margin-bottom: 0 !important;
			// Bleed the dark background edge-to-edge without affecting layout width.
			clip-path: inset(0 -100vmax);
			box-shadow: 0 0 0 100vmax #0F1824;
		}
	}

	.center,
	.centered,
	.text-center {

		&,
		&>* {
			text-align: center !important;
		}
	}

	hr {
		border-top: 1px solid #00000012;
		border-bottom: 0px solid #00000012;
		background: transparent;
		margin-top: 64px !important;
		margin-bottom: 64px !important;
	}

	.extra-content {
		// background-color: red;
		padding: 32px;
		margin: 0 auto;
		max-width: 1500px;
		color: var(--dark);

		&.center {

			>h1,
			>div {
				margin-left: auto;
				margin-right: auto;
			}
		}

		p {
			margin: 0 0 1.25rem;
			line-height: 1.75;
			// text-align: justify;
		}

		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			font-size: 2.25em;
			margin: 0 0 1.25rem;
			line-height: 1.2;
			letter-spacing: 0.01em;
		}

		h1,
		h2,
		h3 {
			font-family: "Cormorant Garamond", serif;
		}

		ul,
		ol {
			margin: 0 0 1.25rem;
			padding-left: 1.5rem;
		}

		ul {
			list-style: disc;
		}

		ol {
			list-style: decimal;
		}

		li {
			margin-bottom: 0.6rem;
			line-height: 1.6;
			padding-left: 0.25rem;

			&::marker {
				color: var(--primary);
			}
		}

		a {
			color: var(--primary);
			text-decoration: underline;
			text-underline-offset: 2px;

			&:hover {
				color: var(--primary-hover);
			}
		}

		blockquote {
			margin: 1.5rem 0;
			padding: 0.75rem 0 0.75rem 1.25rem;
			background: rgba(198, 161, 91, 0.08);
			font-style: italic;
		}

		pre {
			overflow-x: auto;
			padding: 1rem;
		}

		code,
		pre {
			font-family: monospace;
		}

		img {
			max-width: 100%;
			height: auto;
			border-radius: 4px;
		}

		&.small {

			>h1,
			>div {
				max-width: 700px;
			}

			font-size: 0.9rem;

			h1,
			h2,
			h3,
			h4,
			h5,
			h6 {
				font-size: 1.5em;
			}
		}

		@media screen and (max-width: 768px) {
			padding: 0 20px;

			h1,
			h2,
			h3,
			h4,
			h5,
			h6 {
				font-size: 1.65em;
			}
		}

		&.inverted {
			color: #C7CBD1;
			background: #0F1824;
			// 30% more breathing room than the base .extra-content vertical padding.
			padding-top: calc(64px * 1.3);
			padding-bottom: calc(64px * 1.3);
			// Bleed the dark background edge-to-edge without affecting layout width.
			clip-path: inset(0 -100vmax);
			box-shadow: 0 0 0 100vmax #0F1824;

			h1,
			h2,
			h3,
			h4,
			h5,
			h6 {
				color: #FFFFFF;
			}

			strong,
			b {
				color: #FFFFFF;
			}

			a {
				color: var(--primary);

				&:hover {
					color: var(--primary-hover);
				}
			}

			blockquote {
				border-left-color: var(--primary);
				background: rgba(255, 255, 255, 0.06);
			}
		}
	}

	// Shared rhythm + list/link treatment for the markdown content blocks
	// rendered across About/Management/Capital/Services (.about, .extra) and
	// the "how we work" style item cards (.item-content).
	.about,
	.extra,
	.item-content {

		ul,
		ol {
			margin: 0 0 1.25rem;
			padding-left: 1.5rem;
			text-align: left;
		}

		ul {
			list-style: disc;
		}

		ol {
			list-style: decimal;
		}

		li {
			margin-bottom: 0.6rem;
			line-height: 1.6;

			&::marker {
				color: var(--primary);
			}
		}

		p {
			margin-bottom: 1rem;

			&:last-child {
				margin-bottom: 0;
			}
		}

		a {
			color: var(--primary);
			text-decoration: underline;
			text-underline-offset: 2px;

			&:hover {
				color: var(--primary-hover);
			}
		}

		blockquote {
			margin: 1.5rem auto;
			padding: 0.75rem 0 0.75rem 1.25rem;
			background: rgba(198, 161, 91, 0.08);
			font-style: italic;
			text-align: left;
		}

		// Markdown tables (e.g. the "How We Work" steps) styled as a set of
		// aligned columns instead of a plain HTML table.
		table {
			width: 100%;
			table-layout: fixed;
			border-collapse: separate;
			border-spacing: 24px 0;
			margin: 2rem -24px;

			th {
				font-family: "Cormorant Garamond", serif;
				font-size: 1.1rem;
				font-weight: 500;
				letter-spacing: 0.04em;
				text-transform: uppercase;
				text-align: left;
				padding: 0 0 12px;
				border-bottom: 2px solid var(--primary);
			}

			td {
				text-align: left;
				vertical-align: top;
				padding: 20px 22px;
				background: rgba(198, 161, 91, 0.06);
				font-size: 0.95rem;
				line-height: 1.7;
			}

			@media screen and (max-width: 768px) {
				display: block;
				border-spacing: 0;
				margin: 2rem 0;

				thead {
					display: none;
				}

				tbody,
				tr,
				td {
					display: block;
					width: 100% !important;
				}

				td {
					margin-bottom: 16px;

					&:last-child {
						margin-bottom: 0;
					}
				}
			}
		}
	}

	// ".extra" is nested inside ".about.inverted" (see Management.vue), so it
	// inherits the dark palette below through descendant selectors.
	.about.inverted {
		color: #C7CBD1;
		background: #0F1824;
		// 30% more breathing room than the base .limit-width padding.
		padding: calc(12px * 1.3) calc(36px * 1.3);
		// Bleed the dark background edge-to-edge without affecting layout width.
		clip-path: inset(0 -100vmax);
		box-shadow: 0 0 0 100vmax #0F1824;

		* {
			color: inherit;
		}

		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			color: #FFFFFF;
		}

		strong,
		b {
			color: #FFFFFF;
		}

		blockquote {
			border-left-color: var(--primary);
			background: rgba(255, 255, 255, 0.06);
		}

		table td {
			background: rgba(255, 255, 255, 0.06);
		}
	}

	.section {
		padding: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 1em;
		background: white;
		min-height: 10em;

		button {
			padding: 1em 2em;
			font-size: 1.2rem;
			border-radius: var(--ui-radius);
			background-color: var(--primary);
			color: var(--white);
			border: none;
			cursor: pointer;
		}
	}

	pre {
		color: black;
		background-color: #f5f5f5;
		padding: 10px;
		border-radius: 4px;
		overflow-x: auto;
	}

	.no-break {
		white-space: nowrap;
	}

	.pre-line {
		white-space: pre-line;
	}

	.mermaidLoader {
		display: flex;
		flex-flow: column;
		align-content: center;
		align-items: center;
		background: white;

		svg {
			max-width: inherit !important;
		}
	}

	.view-content {
		min-height: 60vh;
		margin-top: 106px;
	}

	.btn {
		&-square {
			border-radius: 0;
		}
	}

	.lower-case,
	.lowercase {
		text-transform: lowercase;
	}

	.upper-case,
	.uppercase {
		text-transform: uppercase;
	}

	.title-like,
	.titlelike {
		text-transform: capitalize;
	}

}
</style>